export default __webpack_public_path__ + "static/media/person_3@2x.c0e82f8c.png";